// 省代订单管理
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class orderPdApi {

    constructor() {
    }
    protected static groupUrl = '/ordering/client';
    protected static orderUrl = '/ordering/client/order';
    
    //获取订货单列表
    public static async getOrderList(data) {
      let uri = this.orderUrl + '/list';
      return await ServerDistApi.send(uri, data);
    }
    //订单管理查询商品信息
    public static async getOrdesblins(data) {
      let uri = '/ordering/client/order/skuItems';
      return await ServerDistApi.send(uri, data);
    }
    //去发货
    public static async sendNew(data) {
      let uri = this.groupUrl + '/send/new';
      return await ServerDistApi.send(uri, data);
    }

    //审核订单
    public static async reviewOrder(data) {
      let uri = this.orderUrl + '/review';
      return await ServerDistApi.send(uri, data);
    }
    //驳回审核订单
    public static async refuseOrder(data){
      let uri = this.orderUrl + '/refuse';
      return await ServerDistApi.send(uri, data);
    }

    //查看详情
    // public static async getOrderInfoList(data) {
    //   let uri = this.orderUrl + '/info';
    //   return await ServerDistApi.send(uri, data);
    // }
    public static async getOrderInfoList(data) {
      let uri = this.orderUrl + '/info1';
      return await ServerDistApi.send(uri, data);
    }

    //sn码查询
    public static async snQuery(data) {
      let uri = this.groupUrl + '/sn/query';
      return await ServerDistApi.get(uri, data);
    }
    // public static async snQuery(data) {
    //   let uri = this.groupUrl + '/sn/queryByOrder';
    //   return await ServerDistApi.get(uri, data);
    // }
    public static async snQueryNew(data) {
      let uri = this.groupUrl + '/sn/queryByOrder';
      return await ServerDistApi.get(uri, data);
    }

    //保存sn码
    public static async saveSN(data) {
      let uri = this.orderUrl + '/tempSn/record';
      return await ServerDistApi.send(uri, data);
    }

    //删除sn码
    public static async deleteTempSn(data) {
      let uri = this.orderUrl + '/tempSn/rm';
      return await ServerDistApi.send(uri, data);
    }

    //查询已保存的sn码
    public static async getTempSn(data) {
      let uri = this.orderUrl + '/tempSn/get';
      return await ServerDistApi.get(uri, data);
    }

    //审核时修改商品
    //查询可添加的商品
    public static async modifyQuerySku(data){
      let uri = this.orderUrl + '/itemMergeQuery';
      return await ServerDistApi.send(uri, data);
    }
    //审核的时候修改商品
    public static async modifySku(data){
      let uri = this.orderUrl + '/itemMerge';
      return await ServerDistApi.send(uri, data);
    }
}

